import { render, staticRenderFns } from "./InformationView.vue?vue&type=template&id=d8291d40&scoped=true&"
import script from "./InformationView.vue?vue&type=script&lang=ts&"
export * from "./InformationView.vue?vue&type=script&lang=ts&"
import style0 from "./InformationView.vue?vue&type=style&index=0&id=d8291d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8291d40",
  null
  
)

export default component.exports